import React, { useState } from "react";
import ModelImg2 from "../../assets/images/ModelImg2.png";
import { MaleModel3D } from "../Common/MaleModel/MaleModel3D";
import { Spinemodel } from "../Common/SpineModel/Spinemodel";
import { title } from "framer-motion/client";

export const OriginOfPain = ({
  selectedPainLocation,
  setPatientMedicationInfo,
  patientMedicationInfo,
}) => {
  const [OriginOfPainInfo, setOriginOfPainInfo] = useState({
    currentPainEpisode: "",
  });
  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setPatientMedicationInfo({
      ...patientMedicationInfo,
      [name]: value,
    });
  };
  return (
    <>
      <div className="flex justify-center gap-4 w-full">
        <div className="flex-1 2xl:p-4 xl:p-4 lg:p-4 md:p-4 p-1 flex justify-start items-start relative">
          <div className="absolute top-0 -left-[20vw] w-full h-full gradientBg" />

          <div className=" 2xl:p-4 xl:p-4 lg:p-4 md:p-4 p-1 w-full rounded-lg flex flex-col justify-start items-start gap-8 relative z-20">
            <div className="flex flex-col justify-start gap-4 items-start w-full ">
              <label
                htmlFor="date"
                className="2xl:text-[1.2vw] xl:text-[1.2vw] lg:text-[1.2vw] md:text-[1.2vw] text-[4vw] font-mainFont font-[500] text-[#333333]"
              >
                Approximately when the pain did begin?
              </label>
              
              <div className="flex w-full flex-col 2xl:flex-row xl:flex-row lg:flex-row md:flex-col justify-between items-center gap-3">
                <div className="flex-1 flex-shrink-0 w-full">
                  <select
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value !== "") { // Only update if a valid option is selected
                        setPatientMedicationInfo({
                          ...patientMedicationInfo,
                          whenPainBegin: value,
                        });
                      }
                    }}
                    value={patientMedicationInfo.whenPainBegin || ""}
                    className=" w-full px-4 py-2 rounded-full inputShado  outline-none font-mainFont font-[500] 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] placeholder:text-[#333333] border border-[#d4d4d4] placeholder:font-[400] text-black bg-[#f0f0f0]"
                  >
                    <option value="">-- Select Year --</option>
                    <option value="1 year">1 Year</option>
                    <option value="2 years">2 Year</option>
                    <option value="3 years">3 Year</option>
                    <option value="More then 3 years">Or Older</option>
                  </select>
                </div>
                <div className="flex-1 w-full flex-shrink-0">
                  <select
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value !== "") { // Only update if a valid option is selected
                        setPatientMedicationInfo({
                          ...patientMedicationInfo,
                          whenPainBeginMonths: value,
                        });
                      }
                    }}
                    value={patientMedicationInfo?.whenPainBeginMonths || ""}
                    className=" w-full px-4 py-2 rounded-full inputShado  outline-none font-mainFont font-[500] 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] placeholder:text-[#333333] border border-[#d4d4d4] placeholder:font-[400] text-black bg-[#f0f0f0]"
                  >
                    <option value="">-- Select Months --</option>
                    <option value='6 months'>6 Months</option>
                    <option value='8 months'>8 Months</option>
                    <option value='10 months'>10 Months</option>
                  </select>
                </div>
              </div>
            </div>

            <div className="flex  flex-col justify-start gap-4 items-start w-full">
              <label
                htmlFor="date"
                className="2xl:text-[1.2vw] xl:text-[1.2vw] lg:text-[1.2vw] md:text-[1.2vw] text-[4vw] text-[#333333] font-mainFont font-[500]"
              >
                What caused current pain episode?
              </label>
              <div className="py-1 px-5  inputShado border border-[#d4d4d4] rounded-full 2xl:w-[60%] xl:w-[60%] lg:w-[60%] md:w-[60%] w-[100%] bg-[#f0f0f0]">
                <input
                  className=" w-full px-4 py-2 rounded-full inputShado  outline-none font-mainFont font-[500] 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] placeholder:text-[#333333]  placeholder:font-[400] text-black bg-[#f0f0f0]"
                  placeholder="Enter pain episode"
                  name="currentPainEpisode"
                  value={patientMedicationInfo?.currentPainEpisode || ""}
                  onChange={handleOnChange}
                />
              </div>
            </div>

            <div className="flex  flex-col justify-start gap-4 items-start w-full">
              <label
                htmlFor="date"
                className="2xl:text-[1.2vw] xl:text-[1.2vw] lg:text-[1.2vw] md:text-[1.2vw] text-[4vw] text-[#333333] font-mainFont font-[500]"
              >
                How did your current pain episode begin?
              </label>
              <div className="py-2 px-5  rounded-md 2xl:w-[60%] xl:w-[60%] lg:w-[60%] md:w-[60%] w-[100%] flex justify-start gap-6 items-center">
                <button
                  type="button"
                  onClick={() => {
                    setOriginOfPainInfo({
                      ...OriginOfPainInfo,
                      currentPainEpisode: "Gradually",
                    });
                    setPatientMedicationInfo({
                      ...patientMedicationInfo,
                      currentPainEpisodeBegin: "Gradually",
                    });
                  }}
                  className={`2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[2.3vw] text-[3.5vw]  rounded-full px-4 py-2  font-[500] font-mainFont btnGraident2 w-full ${
                    patientMedicationInfo.currentPainEpisodeBegin ===
                    "Gradually"
                      ? "text-[#fff] BTNGradientBg"
                      : "bg-white text-black"
                  }`}
                >
                  Gradually{" "}
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setOriginOfPainInfo({
                      ...OriginOfPainInfo,
                      currentPainEpisode: "Suddenly",
                    });
                    setPatientMedicationInfo({
                      ...patientMedicationInfo,
                      currentPainEpisodeBegin: "Suddenly",
                    });
                  }}
                  className={`2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[2.3vw] text-[3.5vw]  rounded-full px-4 py-2  btnGraident2 font-[500] font-mainFont w-full   ${
                    patientMedicationInfo.currentPainEpisodeBegin === "Suddenly"
                      ? "text-[#fff] BTNGradientBg"
                      : "bg-white text-black"
                  }`}
                >
                  Suddenly
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="flex-1 2xl:flex xl:flex lg:flex md:flex hidden justify-center items-center h-[70vh]">
          {/* <MaleModel3D cameraPosition={selectedPainLocation?.cameraPosition}
          distance={selectedPainLocation?.distance} /> */}

          {/* <Spinemodel /> */}
        </div>
      </div>
    </>
  );
};
